import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './App.css';

/*
const Layout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authenticated');
    navigate('/login');
  };
*/
const Layout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Clear localStorage
      localStorage.removeItem('authenticated');

      // Clear server-side config + token
      await fetch('https://qbo.omnivistaweb.com/api/clear-auth', {
        method: 'POST'
      });
    } catch (err) {
      console.warn("⚠️ Logout cleanup failed:", err);
    }

    // Redirect to login page
    navigate('/login');
  };


  return (
    <div className="layout-root">
      <header className="header">
        <h1>GenAiWPS</h1>
      </header>

      <div className="main-body">
        <aside className="sidebar">
          <nav className="nav-tabs">
            <NavLink
              to="/salary-dashboard"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Salary Dashboard
            </NavLink>
            <NavLink
              to="/employee-view"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Employee View
            </NavLink>
            <NavLink
              to="/employee-dashboard"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Employee Dashboard
            </NavLink>
            <NavLink
              to="/employee-center"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Employee Center
            </NavLink>
            <NavLink
              to="/employee-gratuity"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Employee Gratuity
            </NavLink>
            <NavLink
              to="/payroll"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Payroll
            </NavLink>
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                isActive ? 'tab active-tab' : 'tab'
              }
            >
              Settings
            </NavLink>

          </nav>

          <div className="user-footer">
            <div className="user-label">Logged in as <strong>Nael</strong></div>
            <button className="logout-button" onClick={handleLogout}>Logout</button>
          </div>
        </aside>

        <main className="content-area">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
